import { useEffect, useMemo, useState } from "react";
import { getImageFallbackChain, warmMinioVariant } from "../utils/helpers";

// Walks an image through CloudFront sized -> CloudFront original -> API.
// `onFinalError` runs only once every candidate has failed.
const useImageFallback = (src, { skipCloudfront, onFinalError } = {}) => {
  const chain = useMemo(
    () => (skipCloudfront ? [src] : getImageFallbackChain(src)),
    [src, skipCloudfront],
  );
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    setAttempt(0);
  }, [chain]);

  const handleError = (e) => {
    if (attempt === 0 && chain.length > 1) warmMinioVariant(src);
    if (attempt < chain.length - 1) {
      setAttempt(attempt + 1);
      return;
    }
    onFinalError?.(e, chain[attempt]);
  };

  return { currentSrc: chain[Math.min(attempt, chain.length - 1)], handleError };
};

export default useImageFallback;
